import { render, staticRenderFns } from "./Categories.vue?vue&type=template&id=74b1a41a&scoped=true"
import script from "./Categories.vue?vue&type=script&lang=js"
export * from "./Categories.vue?vue&type=script&lang=js"
import style0 from "./Categories.vue?vue&type=style&index=0&id=74b1a41a&prod&lang=css"
import style1 from "./Categories.vue?vue&type=style&index=1&id=74b1a41a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b1a41a",
  null
  
)

export default component.exports